import { ELanguage } from './types'

// url
export const VNW_JOBSEEKER_URL = process.env.NEXT_PUBLIC_VNW_JOBSEEKER_URL
export const MICROSERVICE_DOMAIN = process.env.NEXT_PUBLIC_MICROSERVICE_DOMAIN
export const IMAGE_URL = process.env.NEXT_PUBLIC_IMAGE_URL
export const SSO_DOMAIN = process.env.NEXT_PUBLIC_SSO_DOMAIN
export const VNW_LOGO = `${VNW_JOBSEEKER_URL}/assets-page-container/images/vnw_empower_growth_logo_white.png`
export const FAQ_URL = 'https://faq.vietnamworks.com'
export const APP_ASSET_URL = process.env.NEXT_PUBLIC_APP_ASSET_URL
export const COMPANY_LOGO = `${IMAGE_URL}/img/company-default-logo.svg`

export const ACCESS_TOKEN_LENGTH = 86
// regex
export const PATHNAME_REGEX = new RegExp('/([a-zA-Z0-9-]+-jv|[a-zA-Z0-9-]+-jd)')
export const PATHNAME_EN_REGEX = new RegExp('/([a-zA-Z0-9-]+-jd)')

export const SRC_PATHNAME = [
    '/xem-truoc-dang-tuyen-viec-lam/',
    '/job-posting-preview/',
    '/phan-tich-ho-so',
    '/cv-review'
]

// Health check url
export const HEALTH_CHECK_URL = '/healthcheck/job-details'

// mode
export const isDevelopmentEnv = process.env.NODE_ENV === 'development'

// cookies name
export const VNW_TRACKING_GA = 'VNW_TRACKING_GA'
export const VNW_TRACKING_GA_FIRST = 'VNW_TRACKING_GA_FIRST'

// time
export const DEBOUNCE_CLICK_TIME = 300

// orther
export const VNW_SERECT_KEY = '9ijn8uhb&YGV'
export const postalCode: Record<number, number> = {
    2: 880000, //An Giang
    3: 790000, //Bà Rịa - Vũng Tàu
    4: 960000, //Bắc Kạn
    5: 220000, //Bắc Giang
    6: 260000, //Bạc Liêu
    7: 790000, //Bắc Ninh
    8: 930000, //Bến Tre
    9: 810000, //Biên Hòa
    10: 820000, //Bình Định
    11: 590000, //Bình Dương
    12: 830000, //Bình Phước
    13: 800000, //Bình Thuận
    14: 970000, //Cà Mau
    15: 900000, //Cần Thơ
    16: 270000, //Cao Bằng
    17: 550000, //Đà Nẵng
    18: 630000, //Đắk Lắk
    19: 810000, //Đồng Nai
    20: 870000, //Đồng Tháp
    21: 600000, //Gia Lai
    22: 310000, //Hà Giang
    23: 400000, //Hà Nam
    24: 100000, //Hà Nội
    25: 4, //Hà Tây ==
    26: 480000, //Hà Tĩnh
    27: 170000, //Hải Dương
    28: 180000, //Hải Phòng
    29: 700000, //Hồ Chí Minh
    30: 350000, //Hòa Bình
    31: 530000, //Huế
    32: 160000, //Hưng Yên
    33: 650000, //Khánh Hòa
    34: 580000, //Kon Tum
    35: 390000, //Lai Châu
    36: 670000, //Lâm Đồng
    37: 240000, //Lạng Sơn
    38: 330000, //Lào Cai
    39: 850000, //Long An
    40: 420000, //Nam Định
    41: 460000, //Nghệ An
    42: 430000, //Ninh Bình
    43: 660000, //Ninh Thuận
    44: 290000, //Phú Thọ
    45: 620000, //Phú Yên
    46: 510000, //Quảng Bình
    47: 560000, //Quảng Nam
    48: 570000, //Quảng Ngãi
    49: 200000, //Quảng Ninh
    50: 520000, //Quảng Trị
    51: 950000, //Sóc Trăng
    52: 360000, //Sơn La
    53: 840000, //Tây Ninh
    54: 410000, //Thái Bình
    55: 250000, //Thái Nguyên
    56: 440000, //Thanh Hóa
    57: 530000, //Thừa Thiên-Huế
    58: 860000, //Tiền Giang
    59: 940000, //Trà Vinh
    60: 300000, //Tuyên Quang
    61: 920000, //Kiên Giang
    62: 890000, //Vĩnh Long
    63: 280000, //Vĩnh Phúc
    65: 320000, //Yên Bái
    66: 3, //Khác
    69: 380000, //Điện Biên
    70: 1, //Quốc tế
    71: 2, //ĐBSCL
    72: 910000, //Hậu Giang
    73: 640000, //Đắk Nông
    74: 880000, //An Giang
    75: 790000, //Bà Rịa - Vũng Tàu
    76: 960000, //Bắc Kạn
    77: 220000, //Bắc Giang
    78: 260000, //Bạc Liêu
    79: 790000, //Bắc Ninh
    80: 930000, //Bến Tre
    81: 810000, //Biên Hòa
    82: 820000, //Bình Định
    83: 590000, //Bình Dương
    84: 830000, //Bình Phước
    85: 800000, //Bình Thuận
    86: 970000, //Cà Mau
    87: 900000, //Cần Thơ
    88: 270000, //Cao Bằng
    89: 550000, //Đà Nẵng
    90: 630000, //Đắk Lắk
    91: 810000, //Đồng Nai
    92: 870000, //Đồng Tháp
    93: 600000, //Gia Lai
    94: 310000, //Hà Giang
    95: 400000, //Hà Nam
    96: 100000, //Hà Nội
    97: 4, //Hà Tây ==
    98: 480000, //Hà Tĩnh
    99: 170000, //Hải Dương
    100: 180000, //Hải Phòng
    101: 700000, //Hồ Chí Minh
    102: 350000, //Hòa Bình
    103: 530000, //Huế
    104: 160000, //Hưng Yên
    105: 650000, //Khánh Hòa
    106: 580000, //Kon Tum
    107: 390000, //Lai Châu
    108: 670000, //Lâm Đồng
    109: 240000, //Lạng Sơn
    110: 330000, //Lào Cai
    111: 850000, //Long An
    112: 420000, //Nam Định
    113: 460000, //Nghệ An
    114: 430000, //Ninh Bình
    115: 660000, //Ninh Thuận
    116: 290000, //Phú Thọ
    117: 620000, //Phú Yên
    118: 510000, //Quảng Bình
    119: 560000, //Quảng Nam
    120: 570000, //Quảng Ngãi
    121: 200000, //Quảng Ninh
    122: 520000, //Quảng Trị
    123: 950000, //Sóc Trăng
    124: 360000, //Sơn La
    125: 840000, //Tây Ninh
    126: 410000, //Thái Bình
    127: 250000, //Thái Nguyên
    128: 440000, //Thanh Hóa
    129: 530000, //Thừa Thiên-Huế
    130: 860000, //Tiền Giang
    131: 940000, //Trà Vinh
    132: 300000, //Tuyên Quang
    133: 920000, //Kiên Giang
    134: 890000, //Vĩnh Long
    135: 280000, //Vĩnh Phúc
    136: 320000, //Yên Bái
    137: 3, //Khác
    138: 380000, //Điện Biên
    139: 1, //Quốc tế
    140: 2, //ĐBSCL
    141: 910000, //Hậu Giang
    142: 640000 //Đắk Nông
}

export const BLUR_DEFAULT_IMAGE =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkiPq/CQADyAINhiva0AAAAABJRU5ErkJggg=='

/**
 * VNW-28590 A/B testing Job analysis
 *
 * 10% section see pattern A
 * 10% section see pattern B
 * 80% section see pattern C
 *
 * @author Thien Tran
 * @since Mar 18, 2024
 */
export enum EJobAnalysisType {
    A = 'A',
    B = 'B',
    NONE = 'NONE'
}
export const minA = 0 // 0%
export const maxA = 50 // 50%
export const minB = 0 // 0%
export const maxB = 0 // 0%

export const ABJobAnalysisKey = 'ABJobAnalysis'
export const REQUIRED_COVER_LETTER = 1

export const nationalityList = (langCode: ELanguage) => {
    const nationalityList = {
        en: [
            { id: 1, name: 'Vietnamese' },
            { id: 2, name: 'Foreigner' }
        ],
        vi: [
            { id: 1, name: 'Người Việt Nam' },
            { id: 2, name: 'Người nước ngoài' }
        ]
    }

    return nationalityList[langCode]
}

export const genders = (langCode: ELanguage) => {
    const data = {
        en: [
            { id: 1, name: 'Male' },
            { id: 2, name: 'Female' }
        ],
        vi: [
            { id: 1, name: 'Nam' },
            { id: 2, name: 'Nữ' }
        ]
    }

    return data[langCode]
}

export const maritalsStatus = (langCode: ELanguage) => {
    const data = {
        en: [
            { id: 1, name: 'Single' },
            { id: 2, name: 'Married' }
        ],
        vi: [
            { id: 1, name: 'Độc thân' },
            { id: 2, name: 'Đã kết hôn' }
        ]
    }

    return data[langCode]
}

export const workingType = (langCode: ELanguage, workingTypeId?: number) => {
    const data = {
        en: [
            { id: 1, name: 'Full-time' },
            { id: 2, name: 'Part-time' },
            { id: 3, name: 'Internship' },
            { id: 4, name: 'Freelancer' },
            { id: 5, name: 'Seasonal' },
            { id: 6, name: 'Other' },
            { id: 7, name: 'Online Jobs' }
        ],
        vi: [
            { id: 1, name: 'Toàn thời gian' },
            { id: 2, name: 'Bán thời gian' },
            { id: 3, name: 'Thực tập' },
            { id: 4, name: 'Nghề tự do' },
            { id: 5, name: 'Hợp đồng thời vụ' },
            { id: 6, name: 'Khác' },
            { id: 7, name: 'Việc Làm Online' }
        ]
    }

    if (workingTypeId) {
        const workingTypeItems = data[langCode].filter((item) => item.id === workingTypeId)
        if (workingTypeItems.length > 0) {
            return workingTypeItems[0].name ?? ''
        }
        return ''
    }

    return data[langCode] ?? ''
}

